import { render, staticRenderFns } from "./AddKpiData.vue?vue&type=template&id=1cf95334&scoped=true&"
import script from "./AddKpiData.vue?vue&type=script&lang=js&"
export * from "./AddKpiData.vue?vue&type=script&lang=js&"
import style0 from "./AddKpiData.vue?vue&type=style&index=0&id=1cf95334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf95334",
  null
  
)

export default component.exports